import { Upload } from '@aws-sdk/lib-storage';
import AssetApi from '../api/asset-api.js';
import { create } from 'lodash';



async function uploadAsset(assetType, file, pathArgs) {

  const preSignedUrlResponse = await AssetApi.postPreSignedUploadUrl({
      assetType,
      fileName: file.name,
      fileSize: file.size,
      contentType: file.type,
      pathArgs
    });

  const preSignedUrl = preSignedUrlResponse.data.preSignedUrl;
  const targetUri = preSignedUrlResponse.data.targetUri;

  const uploadResponse = await fetch(preSignedUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type
    },
    body: file,
  });

  if(uploadResponse.status !== 200){
    throw new Error("File upload failed, Status: " + uploadResponse.status + " - " + uploadResponse.statusText);
  }

  // The uploaded object carries no name of its own - the asset record gets it from here.
  const newAssetResponse = await AssetApi.postNewAsset(targetUri, file.name);

  return newAssetResponse.data;
}

export async function uploadFormFile(file, formId, formResponseId, formFieldId) {
    return await uploadAsset("FormAttachment", file, { formId, formResponseId, formFieldId });
}

export default uploadAsset;